"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MobileStepper_1 = __importDefault(require("@mui/material/MobileStepper"));
const MobileStepper = ({ steps, activeStep, backButton, nextButton, ...rest }) => {
    return (react_1.default.createElement(MobileStepper_1.default, { "data-testid": "mobile-stepper", variant: "dots", steps: steps, activeStep: activeStep, backButton: backButton || react_1.default.createElement(react_1.default.Fragment, null), nextButton: nextButton || react_1.default.createElement(react_1.default.Fragment, null), ...rest }));
};
exports.default = MobileStepper;
